/**
 * Error carrying a vue-i18n key (+ optional params) instead of a final
 * message. The POS V2 store layer cannot import the i18n instance (it touches
 * `navigator` at module scope, breaking node test runs), so the UI layer
 * translates: `$t(error.i18nKey, error.params)`.
 */
export class PosV2Error extends Error {
  readonly i18nKey: string;
  readonly params?: Record<string, unknown>;

  constructor(i18nKey: string, params?: Record<string, unknown>) {
    super(i18nKey);
    this.name = 'PosV2Error';
    this.i18nKey = i18nKey;
    this.params = params;
  }
}
